export default __webpack_public_path__ + "static/media/banner.ae2fe826.jpg";